;
(function($) {

  $(document).ready(function() {

    $('#mobile-menu').click(function() {
      $(this).toggleClass('open');

      $('.mobile-menu').fadeToggle();
      $('.utility-menu').fadeToggle();
    });

    $('.current_page_item:contains(Locations)').removeClass('current-menu-item current_page_item');

    $("#menu-primary .menu-item-type-custom").click(function() {
      $('html, body').animate({
        scrollTop: $("#locations").offset().top
      }, 1000);
    });
  });


  $(window).load(function() {


  });


  $(window).resize(function() {


  });

  /**
  * Optional Pinned Header
  */
  $(window).scroll(function(event) {
    var scroll = $(window).scrollTop();

    if (scroll > 84) {
      $('header').addClass('scroll');
    } else {
      $('header').removeClass('scroll');
    }
  });

})(jQuery);
